import React from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { Badge } from 'antd';

import { ENotificationType } from 'v2/interfaces/notification';
import notificationService from 'v2/services/notifications';

export default function Subscriptions() {
  const [notifications] = useObservable(() => notificationService.getListGroupNotifications(), []);

  const recurringDateChange = (notifications || []).find(n => n.type === ENotificationType.RECURRING_DATE_CHANGE);
  if (!recurringDateChange?.quantity) return null;

  return (
    <Link to={`/producer/notifications/${ENotificationType.RECURRING_DATE_CHANGE}`}>
      <div className='flex items-center justify-between px-4 py-2.5 transition-colors hover:bg-[#f5f5f5]'>
        <span className='text-sm font-medium text-[#37474f]'>Assinaturas</span>
        <Badge count={recurringDateChange?.quantity || 0} color='blue' showZero />
      </div>
    </Link>
  );
}
